import { render, staticRenderFns } from "./CommunicatorRegister.vue?vue&type=template&id=1f4ab1a6&scoped=true&"
import script from "./CommunicatorRegister.vue?vue&type=script&lang=js&"
export * from "./CommunicatorRegister.vue?vue&type=script&lang=js&"
import style0 from "./CommunicatorRegister.vue?vue&type=style&index=0&id=1f4ab1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ab1a6",
  null
  
)

export default component.exports